export default __webpack_public_path__ + "static/media/pcs.75b1288c.svg";